/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AIDataset,
    AIDatasetFromJSON,
    AIDatasetFromJSONTyped,
    AIDatasetToJSON,
} from './';

/**
 * 
 * @export
 * @interface ImportAIDatasetResponse
 */
export interface ImportAIDatasetResponse {
    /**
     * 
     * @type {Array<AIDataset>}
     * @memberof ImportAIDatasetResponse
     */
    datasets: Array<AIDataset>;
}

export function ImportAIDatasetResponseFromJSON(json: any): ImportAIDatasetResponse {
    return ImportAIDatasetResponseFromJSONTyped(json, false);
}

export function ImportAIDatasetResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportAIDatasetResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'datasets': ((json['datasets'] as Array<any>).map(AIDatasetFromJSON)),
    };
}

export function ImportAIDatasetResponseToJSON(value?: ImportAIDatasetResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'datasets': ((value.datasets as Array<any>).map(AIDatasetToJSON)),
    };
}


